import { ColorPicker } from 'element-ui'

const YColorPicker = ColorPicker
YColorPicker.$depends = [ColorPicker]
YColorPicker.$name = 'y-color-picker'
YColorPicker._name = 'ColorPicker 颜色选择器'

export default YColorPicker
